import React, { useEffect, useState } from "react";
import classes from "./reviewsList.module.scss";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ReviewCard from "../review card/ReviewCard";
import { Link } from "react-router-dom";
import ReviewsCarousel from "../Reviews Carousel/ReviewsCarousel";
import { ArrowRightAlt } from "@mui/icons-material";
import routes from "../../requests/routes";
const ReviewsList = (props) => {
  return (
    <div className={classes.main}>
      <div className={classes.secHeader}>{props.title && <h3>Reviews</h3>}</div>
      <div className={classes.container}>
        {props.reviews?.map((card) => (
          <ReviewCard
            id={card?._id}
            key={card?._id}
            progId={card?.program?._id}
            img={card?.user?.image}
            title={card?.user?.fullName}
            programName={card?.program?.name}
            startDate={card?.program?.startDate}
            endDate={card?.program?.endDate}
            location={card?.program?.location}
            load={props?.load}
            content={card?.text}
            rating={card?.rating}
            nationality={card?.user?.nationality}
            email={card?.user?.email}
            phone={card?.user?.phoneNO}
            isReview={true}
          />
        ))}
      </div>
      {!props.load && !props.admin && (
        <Link to="/reviews" className={"see_more"} scroll="yes">
          See More
          <ArrowRightAlt />
        </Link>
      )}
    </div>
  );
};

export default ReviewsList;
